import { render, staticRenderFns } from "./CouponSelect.vue?vue&type=template&id=4524a679&scoped=true&"
import script from "./CouponSelect.vue?vue&type=script&lang=ts&"
export * from "./CouponSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CouponSelect.vue?vue&type=style&index=0&id=4524a679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524a679",
  null
  
)

export default component.exports